import alt from 'components/Dispatcher';
import {ActionsBase} from '@store/@types/alt';
import {DashboardDateRange} from '@store/@types/dash/DashboardDateRange';

interface AsyncActions {}

interface SyncActions {
  enterTopicRollup(): void;
  leaveTopicRollup(): void;
  setDateRange(range: DashboardDateRange): void;
}

class DashboardDateRangeActions extends ActionsBase<AsyncActions, SyncActions>() {
  constructor() {
    super();
    this.generateActions('enterTopicRollup', 'leaveTopicRollup', 'setDateRange');
  }
}

export default alt.createActions<AsyncActions, SyncActions>(DashboardDateRangeActions);
